import React, { useState,useEffect } from 'react';
import styles from './Questions.module.scss'
import Question from '../../../partials/Questions/Question';

const Questions = ({ question, feedback }) => {

    const [currentQuestion, setCurrentQuestion] = useState(question);

    useEffect(() => {
        setCurrentQuestion(question)
    }, [question])

    const handleAnswers = (answer) => {
        const answerFeedback = answer.status === 'failed' && !answer.correct ? 
                              answer.feedback.failed : 
                              answer.feedback.success 

        feedback(answerFeedback)
    }
  
    return (
        <div className={styles.container}>

            <div className={styles.questionsContainer}>

            { currentQuestion &&
                <Question 
                    data={currentQuestion}
                    feedback={handleAnswers}
                    locked={!false}
                    showSubmit={false}
            />
            }

            </div>
        </div>
    )


}

export default Questions;